<template>
  <DynamicStepStep 
    :key="stepKey"
    :protocol="protocol" 
    :step="currentStep" 
    :stepValues="currentStepValues" 
    :relatedStepValues="relatedStepValues()"
    @previous-page="previous"
    @next-page="next"
    @save-state="saveState"
    @update-fields="updateFields"
    @error="error"
  />
</template>

<script>
import DynamicStepStep from "./steps/DynamicStepStep"
import dynamicEvents from "../mixins/dynamicEvents"
export default {
  props: ["protocol", "step", "stepValues"],
  components: { DynamicStepStep },
  mixins: [dynamicEvents],
  data() {
    return {
      currentStep: this.step,
      currentStepValues: this.stepValues,
      stepKey: this.getNewStepKey()
    }
  },
  watch: {
    // whenever question changes, this function will run
    step: function (newStep, oldStep) {
      this.currentStep = newStep
    },
    stepValues: function(newStepValues, oldStepValues) {
      this.currentStepValues = newStepValues
      // Solution to re render bug. Force new key for component to re-render when dynamiv page has changed
      this.stepKey = this.getNewStepKey()
    }
  },
  methods: {
    getNewStepKey() {
      return this.$route.params.page + Math.floor(Math.random() * 100000000)
    },
    relatedStepValues() {
      if (this.currentStep.pivot.config) {
        let config = JSON.parse(this.currentStep.pivot.config);
        if(this.protocol.related_protocol) {
          if(this.protocol.related_protocol.steps[config.vue_storage_path]) {
            return this.protocol.related_protocol.steps[config.vue_storage_path].saved_values
          }
        }
      }
      return null
    }
  }
}
</script>